import { apiPost } from "../../../utils";

export const getTrackedVesselAPI = (data) => {
  return apiPost("/api/vessel/get-tracked-vessels", data);
};

export const createVesselContractAPI = (data) => {
  return apiPost(`/api/contract/create-vessel-contract`, data);
};